"use client"

import { ComingSoon } from "@/app/components/coming-soon"
import type { CollectionId } from "@anaconda/core/nft-collection/types"
import { NavigationTrigger, cn } from "@rarible_int/anaconda_ui_components"
import BaseLink from "next/link"
import {
  useCollectionActiveLinkChecker,
  useCollectionPageHref,
} from "../../navigation/collection"
import type { CollectionPageType } from "../../navigation/collection/collection-page-type"

export function CollectionPageLink(props: {
  children: React.ReactNode
  pageType: CollectionPageType
  collectionId: CollectionId
  disabled?: boolean
}) {
  const active = useCollectionActiveLinkChecker(
    props.collectionId,
    props.pageType,
  )
  const href = useCollectionPageHref(props.collectionId, props.pageType)

  return (
    <Container disabled={props.disabled}>
      <NavigationTrigger asChild disabled={props.disabled} active={active}>
        <BaseLink
          href={href}
          className={cn({ "pointer-events-none": props.disabled })}
        >
          {props.children}
        </BaseLink>
      </NavigationTrigger>
    </Container>
  )
}

function Container({
  children,
  disabled,
}: {
  children: React.ReactNode
  disabled?: boolean
}) {
  if (!disabled) return <>{children}</>

  return (
    <ComingSoon>
      <div>{children}</div>
    </ComingSoon>
  )
}
